import Swiper from "swiper";
import LazyLoad from "vanilla-lazyload";
import "../components/forms/fields/date/date";
import "../components/forms/fields/select/select";

(function($) {
    $(function() {
        $(".store-details-header__mobile").on("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            let target = $(e.currentTarget)
                .parent()
                .toggleClass("active");
        });
        if ($(".store-menu-product").length) {
            var lazyLoadInstance = new LazyLoad({
                elements_selector: ".lazy",
            });
        }

        $('input[type="checkbox"]').each(function(i, e) {
            var checkbox = $(e),
                label = checkbox.siblings("label");
            label.addClass("label-container");
            checkbox.remove();
            $(e).appendTo(label);
            $('<span class="checkmark"></span>').appendTo(label);
        });

        var mySwiper = new Swiper(".js-swiper-container", {
            loop: true,
            autoplay: true,
            pagination: {
                el: ".swiper-pagination",
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            scrollbar: {
                el: ".swiper-scrollbar",
            },
        });
    });
})(jQuery);
